import MyTeamWorkingInformationComponent from "../components/MyTeamWorkingInformation";
import useMyTeamWorkingInformation from "../hooks/useMyTeamWorkingInformation";

function MyTeamWorkingInformation() {
  const useMyTeamWorkingInformationProps = useMyTeamWorkingInformation();
  return (
    <MyTeamWorkingInformationComponent {...useMyTeamWorkingInformationProps} />
  );
}

export default MyTeamWorkingInformation;
